export default __webpack_public_path__ + "static/media/phone.dcc6192b.png";